import { Helmet } from "react-helmet";
import { service } from "../../state_management/actionTypes";

export const GlobalSeoSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "CleaningService",
    name: "CleanBee",
    url: "https://cleanbee.ie/",
    logo: "https://cleanbee.ie/nuoroda-i-jusu-logo.png",
    image: "https://cleanbee.ie/nuoroda-i-reprezentacine-nuotrauka.jpg",
    description:
      "Premium cleaning services in Ireland. Trusted by over 100,000 satisfied customers.",
    priceRange: "€€",
    areaServed: {
      "@type": "Country",
      name: "Ireland"
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+35316994255",
      contactType: "customer service",
      areaServed: "IE",
      availableLanguage: "en"
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      bestRating: "5",
      worstRating: "1",
      reviewCount: "1650",
      description: "Based on 1,100+ Google reviews and 550+ Trustpilot reviews."
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export const ServiceSeoSchema = ({
  categoryName,
  categoryDescription,
  services,
  urlPath
}: {
  categoryName: string;
  categoryDescription: string;
  services: service[];
  urlPath?: string;
}) => {
  if (!services || services.length === 0) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: categoryName,
    provider: {
      "@type": "CleaningService",
      name: "CleanBee",
      url: "https://cleanbee.ie/"
    },
    description: categoryDescription,
    areaServed: {
      "@type": "Country",
      name: "Ireland"
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: `${categoryName} Packages`,
      itemListElement: services.map((s) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: s.name
        },
        priceCurrency: "EUR",
        price: s.price_with_discount?.toString() || s.price?.toString() || "0",
        url: `https://cleanbee.ie/${urlPath || "service"}`
      }))
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export const OfferCatalogSeoSchema = ({
  name,
  description,
  services,
  urlPath
}: {
  name: string;
  description: string;
  services: service[];
  urlPath?: string;
}) => {
  if (!services || services.length === 0) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "OfferCatalog",
    name: name,
    description: description,
    itemListElement: services.map((s) => ({
      "@type": "Offer",
      name: s.name,
      description: s.description || s.name,
      priceCurrency: "EUR",
      price: s.price_with_discount?.toString() || s.price?.toString() || "0",
      availability: "https://schema.org/InStock",
      url: `https://cleanbee.ie/${urlPath || "bundles"}`
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};
